import React from 'react';

import '../styles/Text.css';

const Text = ({ text, multiline }) => {

    return (
        <div className={ multiline ? 'text-panel-multiline' : 'text-panel' }>{text}</div>
    );
};

export default Text;